
    <div class="full-height full-width" fxLayout="row">
      <mat-card class="change-password__card">
        <ml-change-password-form (changePassword)="onChangePassword($event)">
        </ml-change-password-form>
      </mat-card>
    </div>
  